/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Interchange_FcInputs */

const en_fc_cmp_interchange_fc = /** @type {(inputs: Fc_Cmp_Interchange_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCP 7 XML, FCPXML, OTIO, EDL, AAF, OMF`)
};

/**
* | output |
* | --- |
* | "FCP 7 XML, FCPXML, OTIO, EDL, AAF, OMF" |
*
* @param {Fc_Cmp_Interchange_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_interchange_fc = /** @type {((inputs?: Fc_Cmp_Interchange_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Interchange_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_interchange_fc(inputs)
});
export { fc_cmp_interchange_fc as "fc.cmp.interchange.fc" }